import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { PostData } from '../../services/PostData';
import { GetData } from '../../services/GetData';
import {
	Row,
	Col,
	Button,
	ButtonDropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Card,
	CardHeader,
	CardFooter,
	CardBody,
	Collapse,
	Form,
	FormGroup,
	FormText,
	Label,
	Input,
	InputGroup,
	InputGroupAddon,
	InputGroupText,
	Table,
	Progress
} from 'reactstrap';
import $ from 'jquery';
import StudentPage from '../../views/StudentPage';

class StudentDashboard extends Component {

	/** set property value **/
	constructor(props) {
		super(props);
		this.state = {
			acyear: '',
			accyear: [],
			allsection: [],
			_message: '',
			alertClass: '',
			posts: [],
			_redirect: false,
		}
	}

	/** this function will be call when page loading **/
	componentDidMount() {

		this.getacyear();
	}

	/** get Academic Year **/
	getacyear() {
		$("#showLoader").show();
		GetData('academic/getacyear').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					accyear: responseJson
				});
				var index = responseJson.findIndex(function (obj) {
					return (obj.iscurrent == 1);
				});
				var academic = $("#year").find("option:eq(1)").val();
				this.setState({
					acyear: responseJson[index].id
				});
				$('#year option').eq(index + 1).prop('selected', true).trigger('change');
				this.getdata();
				this.getallsection();
			}
		});
	}

	/** get Class **/
	getallsection() {

		var ac = $("#year").val();
		$("#showLoader").show();
		GetData('section/getsecbyacyear/' + ac).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					allsection: responseJson
				});
			}
		});
	}

	getdata() {
		$("#showLoader").show();
		var ac = $("#year").val();
		GetData('student/getstdbyac/' + ac).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					posts: responseJson
				});
			}
		});
	}

	gettotalboyscount() {

		var count = 0;

		for (var i = 0; i < this.state.posts.length; i++) {

			if (this.state.posts[i].gender == 'Male') {

				count += 1;
			}
		}

		return count;
	}

	gettotalgirlscount() {

		var count = 0;

		for (var i = 0; i < this.state.posts.length; i++) {

			if (this.state.posts[i].gender == 'Female') {

				count += 1;
			}
		}

		return count;
	}

	getboyscount(cls, sec) {

		var count = 0;

		for (var i = 0; i < this.state.posts.length; i++) {

			if (this.state.posts[i].class == cls && this.state.posts[i].section == sec && this.state.posts[i].gender == 'Male') {

				count += 1;
			}
		}

		return count;
	}

	getgirlscount(cls, sec) {

		var count = 0;

		for (var i = 0; i < this.state.posts.length; i++) {

			if (this.state.posts[i].class == cls && this.state.posts[i].section == sec && this.state.posts[i].gender == 'Female') {

				count += 1;
			}
		}

		return count;
	}

	gettotalcount(cls, sec) {

		var count = 0;

		for (var i = 0; i < this.state.posts.length; i++) {

			if (this.state.posts[i].class == cls && this.state.posts[i].section == sec) {

				count += 1;
			}
		}

		return count;
	}

	render() {

		$("#acyear").hide();
		var acyear = this.state.accyear;

		const renderTodo = this.state.allsection.map((item, index) => {

			return <tbody>
				<tr key={item}>
					<td>{index + 1}</td>
					<td>{item.cls}</td>
					<td>{item.secs}</td>
					<td>{this.getboyscount(item.clas, item.section)}</td>
					<td>{this.getgirlscount(item.clas, item.section)}</td>
					<td>{this.gettotalcount(item.clas, item.section)}</td>
					<td>
						<Progress multi>
							<Progress bar color="info" value={this.getboyscount(item.clas, item.section)} max={this.gettotalcount(item.clas, item.section)} />
							<Progress bar color="warning" value={this.getgirlscount(item.clas, item.section)} max={this.gettotalcount(item.clas, item.section)} />
						</Progress>
					</td>
				</tr>
			</tbody>;
		})

		return (
			<div>
				<StudentPage />
				<div className="animated fadeIn">
					<div className={this.state.alertClass}>
						{this.state._message}
					</div>
					<Row>
						<Col md="12">
							<Card>
								<CardHeader>
									<strong>Student Count List</strong>
								</CardHeader>
								<CardBody>
									<Row id="acyear">
										<Col md="12">
											<select name="acyear" onChange={this.onChange} required id="year">
												<option value="">Select</option>
												{
													acyear.map(function (item) {
														return <option value={item.id}>{item.value}</option>;
													})
												}
											</select>
										</Col>
									</Row>
									<Row>
										<Col xs="12" sm="6" lg="4">
											<Card className="text-white">
												<CardBody className="pb-0" style={{ backgroundColor: '#b6a2da', borderColor: '#b6a2da' }}>
													<div className="float-right">
														<i id="headicon" className="icon-graduation" ></i>
													</div>
													<h4 className="mb-0"><span>{this.state.posts.length}</span></h4>
													<p>Total Students</p>
												</CardBody>
											</Card>
										</Col>
										<Col xs="12" sm="6" lg="4">
											<Card className="text-white">
												<CardBody className="pb-0" style={{ backgroundColor: '#63c2de ', borderColor: '#63c2de ' }}>
													<div className="float-right">
														<i id="headicon" className="fa fa-male" ></i>
													</div>
													<h4 className="mb-0"><span>{this.gettotalboyscount()}</span></h4>
													<p>Boys</p>
												</CardBody>
											</Card>
										</Col>
										<Col xs="12" sm="6" lg="4">
											<Card className="text-white">
												<CardBody className="pb-0" style={{ backgroundColor: '#ffc107', borderColor: '#ffc107' }}>
													<div className="float-right">
														<i id="headicon" className="fa fa-female" ></i>
													</div>
													<h4 className="mb-0"><span>{this.gettotalgirlscount()}</span></h4>
													<p>Girls</p>
												</CardBody>
											</Card>
										</Col>
									</Row>
									<Row>
										<Col md="12">
											<Table responsive striped>
												<thead>
													<tr>
														<th>S.No</th>
														<th>Class</th>
														<th>Section</th>
														<th>Boys</th>
														<th>Girls</th>
														<th>Total</th>
														<th>Split</th>
													</tr>
												</thead>
												{renderTodo}
											</Table>
										</Col>
									</Row>
								</CardBody>
							</Card>
						</Col>
					</Row>
				</div>
			</div>
		)
	}
}

export default StudentDashboard;


// WEBPACK FOOTER //
// ./src/student/StudentDashboard/StudentDashboard.js